import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "@lib/utils";

/** A text input component for forms and user data entry with built-in styling and accessibility features. */
export const Input = ({ className, type, ...props }: React.ComponentProps<"input">) => (
	<InputPrimitive
		type={type}
		data-slot="input"
		className={cn(
			`aria-invalid:border-destructive md:text-sm file:text-foreground placeholder:text-muted-foreground h-8 w-full
			min-w-0 rounded-sm border border-input bg-transparent px-2.5 py-1 text-base text-white transition-colors
			outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium
			hover:border-white focus-visible:border-white disabled:pointer-events-none disabled:cursor-not-allowed
			disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-error-foreground`,
			className,
		)}
		{...props}
	/>
);

Input.displayName = "Input";
